import { Col, Divider, message, Row } from "antd";
import React from "react";
import ProductSearch from "./product.search";
import TableFree from "./free.table";
import { useHardPromotionFormMutate } from "../contexts/hard-promotion-form.context";
import _ from "lodash";

const TYPE = "free";
const PanelFree = () => {
  const {
    state: {
      data: { free },
    },
    dispatch,
  } = useHardPromotionFormMutate();

  const handleSelectProduct = (product_code, option) => {
    if (_.find(free || [], (n) => n.product_code === product_code))
      return message.warning("มีสินค้านี้ในรายการแล้ว");
    dispatch({
      type: "ADD_ITEM",
      payload: { type: TYPE, product_code, product_name: option?.props.label },
    });
  };

  return (
    <>
      <Divider>สิ่งที่ได้รับ</Divider>
      <Row gutter={16} className="mb-2">
        <Col md={20}>
          <ProductSearch onSelect={handleSelectProduct} />
        </Col>
      </Row>
      <TableFree />
    </>
  );
};

export default PanelFree;
